import React, { useState, useContext } from 'react';
import { Button, TextField, Switch,	FormControlLabel} from "@mui/material";
import NotificationManager from 'react-notifications/lib/NotificationManager';
import { AuthContext } from '../../../../contexts/authContext';
import config from '../../../../config';
import configMessage from '../../../../utils/configMessage.json';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios  from 'axios';

const NewUserDialog = ({ isOpen, onClose, callUser }) => {
	const auth = useContext(AuthContext);  	
	const [name, setName] = useState('');
	const [surname, setSurname] = useState('');
	const [password, setPassword] = useState('');
	const [passwordCheck, setPasswordCheck] = useState('');
	const [username, setUsername] = useState('');
	const [eMail, setEmail] = useState('');
	const [agenteCod, setAgenteCod] = useState('');
	const [flagDoppioProfilo, setFlagDoppioProfilo] = useState(false);
	const [flagAdmin, setFlagAdmin] = useState(false);

	const submitIns = async(event) => {
  
		try{
	
			const params = {
				pUserName: username,
				pNome: name,
				pCognome: surname,
				pEMailAddress: eMail,
				pAgenteCod: agenteCod,
				pFlagAdmin: flagAdmin ? 'Y' : 'N',
			};

			let axiosParams = {
				url: '/users/user-ins',
				method: 'post',
				baseURL: config.API_URL,
				headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},  				
				params,
                handleError: true
			}

			const response = await axios(axiosParams);

			let data = response?.data || 0;

			if (data <= 0) {
				let errorMessage = '';
				switch (data) {
					case -2:
						errorMessage = configMessage.NO_PRIVILEGES_ERROR;
						break;
					case -3:
						errorMessage = configMessage.USERNAME_LOST_ERROR;
						break;
					case -4:
						errorMessage = configMessage.PASSWORD_ERROR;
						break;
					case -5:
						errorMessage = configMessage.USERNAME_ERROR;
						break;
					case -6:
						errorMessage = configMessage.SURNAME_LOST_ERROR;
						break;
					case -7:
						errorMessage = configMessage.EMAIL_ERROR;
						break;
					default:
						errorMessage = configMessage.UNEXPECTER_ERROR;
						break;
				}

				NotificationManager.error(errorMessage, "", config.TIMEOUT_MSG_ERROR_GEN);
			} else {
				NotificationManager.success(configMessage.MSG_SUCCESS, "", config.TIMEOUT_MSG_SUCCESS);
				handleCloseModal();
				callUser();
			}

		}catch(error){
			NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
		}
	};

      
	const handleSubmit = () => {
		if (password === passwordCheck) {
			submitIns();
		} else {
			NotificationManager.error("Password does not match", "", config.TIMEOUT_MSG_ERROR_GEN);
		}
	};

	const handleCloseModal = () => {
		setName('');
		setSurname('');
		setPassword('');
		setPasswordCheck('');
		setUsername('');
		setEmail('');
		setAgenteCod('');
		setFlagDoppioProfilo(false);
		setFlagAdmin(false);
		onClose();
	};

	return (
		<Dialog 
            open={isOpen} 
            onClose={onClose}
            className='create-user-dialog'
        >
            <DialogTitle id="dialog-delete-user">
                New User
            </DialogTitle>
            <DialogContent className='dialog-body'>
                <div className='field-box'>
                    <TextField
                        className='text-field'
                        label="Username"
                        name="username"
                        value={username}
                        onChange={(event) => setUsername(event.target.value)}
                        variant='standard'
						inputProps={{
							autocomplete: 'new-password',
							form: {
							autocomplete: 'off',
							},
						}}							
                    />

                    <TextField
                        className='text-field'
                        label="E-mail address"
                        value={eMail}
                        onChange={(event) => setEmail(event.target.value)}
                        variant='standard'
						inputProps={{
							autocomplete: 'new-password',
							form: {
							autocomplete: 'off',
							},
						}}						
                    />
                </div>
                <div className='field-box'>
                    <TextField
                        className='text-field'
                        label="Password"
                        name="Password"
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        variant='standard'
						inputProps={{
							autocomplete: 'new-password',
							form: {
							autocomplete: 'off',
							},
						}}	
						disabled={true}						
                    />

                    <TextField
                        className='text-field'
                        label="Repeat Password"
                        name="RepeatPassword"
                        type="password"
                        value={passwordCheck}
                        onChange={(event) => setPasswordCheck(event.target.value)}
                        variant='standard'
						inputProps={{
							autocomplete: 'new-password',
							form: {
							autocomplete: 'off',
							},
						}}		
						disabled={true}
                    />
                </div>
                <div className='field-box'>
                    <TextField
                        className='text-field'
                        label="Name"
                        name="name"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        variant='standard'
						inputProps={{
							autocomplete: 'new-password',
							form: {
							autocomplete: 'off',
							},
						}}							
                    />

                    <TextField
                        className='text-field'
                        label="Surname"
                        name="cognome"
                        value={surname}
                        onChange={(event) => setSurname(event.target.value)}
                        variant='standard'
						inputProps={{
							autocomplete: 'new-password',
							form: {
							autocomplete: 'off',
							},
						}}							
                    />
                </div>
                <div className='field-box'>
                    <TextField
                        className='text-field'
                        label="Agent. Cod"
                        value={agenteCod}
                        onChange={(event) => setAgenteCod(event.target.value)}
                        variant='standard'
						inputProps={{
							autocomplete: 'new-password',
							form: {
							autocomplete: 'off',
							},
						}}							
                    />
                </div>

                <FormControlLabel
                    control={
                        <Switch
                            name="flagAdmin"
                            checked={flagAdmin}
                            onChange={(event) => setFlagAdmin(event.target.checked) }
                            color="primary"
                        />
                    }
                    label="Administrator"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}  variant="outlined">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} variant='contained'>
                    Save
                </Button>
            </DialogActions>
		</Dialog>
	);
};

export default NewUserDialog;
